module.exports = __webpack_public_path__ + "media/images/application/template/logos/placeholder-logo-wide-55d4da95dc28e545aa965d9efcb121e2.png";